<template>
    <div>
        <creative-document-type v-if="showDocTypeModal"
                                @close="showDocTypeModal = false"
                                ref="creativeDocumentTypeModal"
                                :isTpg="isTpg"
                                @docTypeSelected="docTypeSelected"
                                :documentName="uploadedDocumentName"
                                :docTypes="docTypes"></creative-document-type>

        <doc-deletion-confirmation v-if="showDocDeleteModal"
                                @close="showDocDeleteModal = false"
                                ref="docDeletionConfirmationModal" :msg="confirmationAlertMessage" @confirm="confirm"></doc-deletion-confirmation>

        <workspace-header :providedSecondaryTitle="locationZoneName" :isTpg="isTpg"></workspace-header>

        <div class="workspace-content" :class="{isTpg:isTpg}">
                <div class="workspace-content-fluid-row ">
                    <div class="col col-lg-3">Your Website</div>
                    <div class="col col-lg-7">
                         <div class="empty-set" v-if="!websiteUrl">
                            -
                        </div>
                        <div v-else>
                            <a :href="websiteUrl" target="_NEW" :class="{isTpg:isTpg}">{{ websiteUrl }}</a>
                        </div>

                    </div>
                    <div class="col col-lg-2 workspace-bubble-link" :class="{isTpg:isTpg}">
                        <router-link :to="{ path: '/creative/' + locationZoneID+'/website'}">
                            Update
                        </router-link>
                    </div>
                </div>
            <div v-if="uploadError" class="alert alert-danger" v-html="uploadError" style="margin-top:10px;"></div>
            <div>
                <div class="workspace-content-fluid-row " v-if="showFileUpload">
                    <div class="col col-lg-3">Documents</div>
                    <div class="col col-lg-9">
                        <div v-if="files && files.length < 1 || !files" style="text-align:left;"><i></i></div>
                        <div v-for="file in files" :key="file.name">
                            <div class="file-row" v-if="file != null">
                                <div class="file-name" style="float:left;width:95%;">
                                    <a :href="file.remote_path" target="_blank" :class="{isTpg:isTpg}">
                                         <span v-if="file.name && file.name.length > 40"
                                               v-tooltip="file.name">{{ file.name }}</span>
                                        <span v-else>{{file.name}}</span>
                                        </a>
                                </div>
                                <div class="delete-file-icon"  style="float:left;width:5%;" @click="deleteFile(file)">
                                    <font-awesome-icon icon="times"  aria-hidden="false" />
                                </div>
                            </div>

                        </div>
                        <div class="file-upload-container">
                            <form enctype="multipart/form-data" novalidate > <!-- v-if="isInitial || isSaving" -->
                                <div class="dropbox">
                                    <input type="file" :name="uploadFieldName" :disabled="isSaving" @change="upload($event)" accept="file_extension|image/*" class="input-file">
                                    <!--filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length-->
                                    <p v-if="isInitial">
                                        Drag your file here to begin or click to browse.<br><i>10MB limit</i>
                                    </p>
                                    <p v-if="isSaving">
                                        Uploading {{ fileCount }} files...
                                    </p>
                                    <p v-if="isSuccess">
                                       Your file was successfully uploaded.
                                    </p>
                                    <p v-if="isFailed">
                                        Your file failed to upload; please try again.
                                    </p>
                                </div>
                            </form>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
import CreativeDocumentType from './CreativeDocumentType.vue';
import DocDeletionConfirmation from './DocDeletionConfirmation.vue';

const STATUS_INITIAL = 0; const STATUS_SAVING = 1; const STATUS_SUCCESS = 2; const
  STATUS_FAILED = 3;

export default {
  data() {
    return {
      showFileUpload: true,
      websiteUrl: '',
      locationZoneName: '',
      locationZoneID: null,
      files: [],
      currentStatus: null,
      uploadFieldName: 'photos',
      docTypes: [],
      uploadError: null,
      uploadedDocumentName: '',
      uploadedDocumentType: '',
      fieldName: '',
      fileList: '',
      errors: '',
      formData: null,
      uploadedFile: null,
      fileToDelete: null,
      confirmationAlertMessage: 'Are you sure you want to delete this file?',
      showDocTypeModal: false,
      showDocDeleteModal: false,
    };
  },
  mounted() {
    this.reset();
    this.locationZoneID = this.$route.params.id;
    this.getLocationZone();
    this.getCreativeInfo();
    this.getCreativeDocuments();
    this.getDocTypes();
    this.currentStatus = STATUS_INITIAL;
  },
  methods: {
    getDocTypes() {
      const creativeDocTypeNames = ['Site Photos', 'Renderings', 'Client Deck', 'Press'];

      const self = this;
      this.$http.get('/document_types').then((response) => {
        const allDocTypes = response.data;

        for (let i = 0; i < allDocTypes.length; i++) {
          if ((creativeDocTypeNames.indexOf(allDocTypes[i].name) > -1)) {
            self.docTypes.push(allDocTypes[i]);
          }
        }
      });
    },
    getCreativeInfo() {
      const locationZoneID = this.$route.params.id;
      const self = this;
      this.$http.get(`/creative/${locationZoneID}`).then((response) => {
        if (response.data) {
          if (response.data.data['0']) {
            self.websiteUrl = response.data.data['0'].website_url;
          }
        }
      });
    },
    getCreativeDocuments() {
      const locationZoneID = this.$route.params.id;
      const self = this;
      this.$http.get(`/creative/${locationZoneID}`).then((response) => {
        if (response.data.data) {
          self.files = response.data.data.creative_documents;
        }
      });
    },
    confirm() {
      if (!this.fileToDelete || this.fileToDelete == null) {
        return;
      }

      const self = this;
      this.$http.delete(`/document/${this.fileToDelete.id}`).then((response) => {
        self.files = self.removeFromArray(self.files, self.fileToDelete);
        // if (response.body.error) {
        //     self.uploadError = "Unable to delete file";
        // } else {
        //     self.files = self.removeFromArray(self.files,self.fileToDelete);
        // }
      },
      () => {
        self.uploadError = 'Unable to delete file';
      });
    },
    deleteFile(file) {
      this.fileToDelete = file;
      this.showDocDeleteModal = true;
    },
    removeFromArray(arr, value) {
      return arr.filter((ele) => ele != value);
    },
    upload(event) {
      this.eruploadErrorrors = '';

      const data = new FormData();
      const file = event.target.files[0];

      data.append('client_document_title', event.target.files[0].name);
      data.append('client_document_file', file);
      data.append('location_zone_ids', this.$route.params.id);

      this.uploadedFile = data;
      this.uploadedDocumentName = event.target.files[0].name;

      this.showDocTypeModal = true;
    },
    docTypeSelected(docType) {
      // Add file to array
      this.uploadedDocumentType = docType;
      this.uploadedFile.append('client_document_type_id', docType.id);

      const self = this;
      this.$http.post('/document', this.uploadedFile).then((response) => {
        if (response.body.error) {
          self.uploadError = `<b>There was a problem uploading your file: </b>${self.parseErrors(response.body.data)}`;
          self.currentStatus = STATUS_FAILED;
        } else {
          // success
          self.getCreativeDocuments();
          self.currentStatus = STATUS_SUCCESS;
        }
      },
      (response) => {
        self.uploadError = `<b>There was a problem uploading your file: </b>${self.parseErrors(response.data)}`;
        self.currentStatus = STATUS_FAILED;
      })
        .catch((response) => {
          self.getCreativeDocuments(response);
        });

      // const formData = new FormData();
      // if (!this.fileList.length) return;
      // // append the files to FormData
      // Array
      //     .from(Array(this.fileList.length).keys())
      //     .map(x => {
      //         formData.append(this.fieldName, this.fileList[x], this.fileList[x].name);
      //
      //     });
      // save it
    },
    parseErrors(data) {
      // Parses response from API into better format
      let responseString = '';

      if (!data) {
        responseString = 'No data';
      } else {
        const { fields } = data;

        if (!fields) {
          responseString = 'No fields';
        } else {
          responseString = '<ul>';
          for (const field in fields) {
            if (Object.prototype.hasOwnProperty.call(fields, field)) {
              const fieldErrors = fields[field];
              responseString = `${responseString}<li>${fieldErrors}</li>`;
            }
          }
        }
      }
      responseString = `${responseString}</ul>`;

      return responseString;
    },
    getLocationZone() {
      const locationZoneID = this.$route.params.id;
      const self = this;
      this.$http.get(`/location_zone/${locationZoneID}`).then((response) => {
        self.locationZoneName = `${response.data.location.name} - ${response.data.location_zone.name}`;
      });
    },
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    // save: function() {
    //     // upload data to the server
    //     var newFile = {
    //                     client_document_title:this.uploadedDocumentName,
    //                     client_document_type_id:this.uploadedDocumentType.id,
    //                     client_document_file:this.formData.fileList[0]
    //     };
    //     console.log(this.formData.fileList[0].name);
    //     this.files.push(newFile);
    //
    //     this.currentStatus = STATUS_INITIAL;
    //
    //
    //     this.$http.post('api/v1/document/',newFile).then(function(response)
    //     {
    //         //success
    //         this.currentStatus = STATUS_SUCCESS;
    //     },
    //     function(response) {
    //         this.uploadError = response;
    //         this.currentStatus = STATUS_FAILED;
    //     });
    // },
    // filesChange: function(fieldName, fileList) {
    //     // handle file changes
    //     this.currentStatus = STATUS_SAVING;
    //     this.uploadedDocumentName = fileList[0].name;
    //     this.fieldName = fieldName;
    //     this.fileList = fileList;
    //
    //     const formData = new FormData();
    //
    //     if (!this.fileList.length) return;
    //     // append the files to FormData
    //     Array
    //         .from(Array(this.fileList.length).keys())
    //         .map(x => {
    //             formData.append(this.fieldName, this.fileList[x], this.fileList[x].name);
    //         });
    //
    //     this.formData = formData;
    //     this.$refs.creativeDocumentTypeModal.show();
    //
    //     return;
    // },

  },
  components: { CreativeDocumentType, DocDeletionConfirmation },
  props: ['user-info', 'is-tpg'],
  watch: {

  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },

  },
};

</script>

<style scoped>

/*.file-upload-container {*/
    /*width:100%;*/
    /*border:1px dashed #666;*/
    /*padding:10px;*/
    /*text-align:center;*/
    /*margin-top:25px;*/
    /*border-radius:5px;*/
    /*cursor: pointer;*/
    /*transition:.3s;*/
/*}*/
/*.file-upload-container:hover {*/
    /*background:#666;*/
/*}*/
.input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
}
.file-row {
    padding-top:2px;
    margin-bottom:5px;
    clear:both;
    width:100%;
    border-top: 1px solid #666;
    height:28px;
    line-height:28px;
}
.file-row:first-child {
    border-top: 1px solid #ccc;
}
.delete-file-icon {
    cursor:pointer;
    text-align:right;
}
.delete-file-icon:hover {
    color:#ccc;
}
.file-name {
    cursor: pointer;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.file-name:hover {
    color:#666;
}
.file-name.isTpg a {
    color:black;
}
.file-name.isTpg a:hover {
    color:#666;
}
.dropbox {
    font-size:12px;
    outline: 1px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: #666;
    color: #fff;
    padding: 5px 5px;
    min-height: 100px; /* minimum height */
    position: relative;
    cursor: pointer;
    border-radius: 5px;
    margin-top:20px;
    opacity: .8;
    transition:.2s;
}

.input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
}

.dropbox:hover {
    background: #ccc; /* when mouse over to the drop zone, change color */
    color:#000;
    outline: 0px dashed #efefef;
    opacity: .6;
}

.dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
}
    .upload_errors {
        width:80%;
        margin:0 auto;
        padding:10px;
    }
</style>
